module.exports = __webpack_public_path__ + "static/media/hari.a40821fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/hari.jpg
// module id = 174
// module chunks = 0